<div class="w-full mx-auto p-5 space-y-6">

  <!-- Header -->
  <div class="bg-white p-6 rounded-lg shadow-sm">
    <div class="flex items-center gap-4">
      <button (click)="goBack()" class="p-2 hover:bg-gray-100 rounded-lg transition">
        <svg class="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
        </svg>
      </button>
      <div>
        <h1 class="text-2xl font-bold text-gray-800">Nueva Cesión de Cupo</h1>
        <p class="text-gray-500 mt-1">Transfiera una inscripción de un participante a otro</p>
      </div>
    </div>
  </div>

  <!-- Barra de pasos -->
  <div class="flex items-center justify-center">
    <div class="flex w-full max-w-3xl">
      <ng-container *ngFor="let label of ['Participantes', 'Inscripción', 'Confirmar']; let i = index">
        <div class="flex flex-1 text-center items-center">
          <div class="flex items-center justify-center w-10 h-10 rounded-full transition-all" [ngClass]="{
              'bg-purple-500 text-white shadow-lg': step === i + 1,
              'bg-green-500 text-white': step > i + 1,
              'bg-gray-300 text-gray-600': step < i + 1
            }">
            <span *ngIf="step <= i + 1">{{ i + 1 }}</span>
            <svg *ngIf="step > i + 1" class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clip-rule="evenodd" />
            </svg>
          </div>
          <div class="mx-2 flex-1">
            <span class="text-sm font-medium" [class.text-purple-600]="step === i + 1">{{ label }}</span>
          </div>
          <div *ngIf="i < 2" class="flex-1 h-0.5 bg-gray-300" [ngClass]="{'bg-purple-500': step > i + 1}"></div>
        </div>
      </ng-container>
    </div>
  </div>

  <!-- STEP 1: Selección de Participantes -->
  <div *ngIf="step === 1" class="bg-white p-6 rounded-lg shadow-sm">
    <div class="flex items-center mb-6">
      <div class="w-2 h-8 bg-purple-500 rounded mr-3"></div>
      <h3 class="text-lg font-semibold text-gray-800">Seleccione los Participantes</h3>
    </div>

    <!-- Selector de tipo de inscripción -->
    <div class="mb-6 p-4 bg-gray-50 rounded-lg">
      <label class="block text-sm font-medium text-gray-700 mb-3">Tipo de Inscripción</label>
      <div class="flex gap-4">
        <label class="flex items-center gap-2 cursor-pointer p-3 rounded-lg border-2 transition-all"
          [ngClass]="{'border-purple-500 bg-purple-50': enrollmentType === 'individual', 'border-gray-200 hover:border-gray-300': enrollmentType !== 'individual'}">
          <input type="radio" value="individual" [(ngModel)]="enrollmentType" (change)="onEnrollmentTypeChange()"
            class="text-purple-600 focus:ring-purple-500">
          <div>
            <span class="font-medium text-gray-800">Individual</span>
            <p class="text-xs text-gray-500">Inscripción directa del participante</p>
          </div>
        </label>
        <label class="flex items-center gap-2 cursor-pointer p-3 rounded-lg border-2 transition-all"
          [ngClass]="{'border-purple-500 bg-purple-50': enrollmentType === 'corporate', 'border-gray-200 hover:border-gray-300': enrollmentType !== 'corporate'}">
          <input type="radio" value="corporate" [(ngModel)]="enrollmentType" (change)="onEnrollmentTypeChange()"
            class="text-purple-600 focus:ring-purple-500">
          <div>
            <span class="font-medium text-gray-800">Empresarial</span>
            <p class="text-xs text-gray-500">Inscripción a través de empresa</p>
          </div>
        </label>
      </div>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
      <!-- Participante que cede -->
      <div class="border border-gray-200 rounded-lg p-4">
        <label class="block text-sm font-medium text-red-600 mb-2">
          <svg class="w-4 h-4 inline mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
          </svg>
          Participante que CEDE el cupo
        </label>
        <p-dropdown [options]="participants" [(ngModel)]="fromParticipantId" (onChange)="onFromParticipantChange()"
          optionLabel="firstName" optionValue="id" [filter]="true" filterBy="firstName,lastName,documentId"
          placeholder="Buscar participante..." styleClass="w-full" [showClear]="true"
          (onFilter)="onSearchParticipants($event)">
          <ng-template let-participant pTemplate="item">
            <div class="flex items-center gap-2">
              <div class="w-8 h-8 rounded-full bg-red-100 flex items-center justify-center flex-shrink-0">
                <span class="text-red-600 text-xs font-medium">
                  {{ participant.firstName?.[0] }}{{ participant.lastName?.[0] }}
                </span>
              </div>
              <div>
                <div class="font-medium">{{ participant.firstName }} {{ participant.lastName }}</div>
                <div class="text-xs text-gray-500">{{ participant.typeDocument }} {{ participant.documentId }}</div>
              </div>
            </div>
          </ng-template>
          <ng-template let-participant pTemplate="selectedItem">
            <div class="flex items-center gap-2" *ngIf="participant">
              <span class="font-medium">{{ participant.firstName }} {{ participant.lastName }}</span>
              <span class="text-xs text-gray-500">({{ participant.documentId }})</span>
            </div>
          </ng-template>
        </p-dropdown>
      </div>

      <!-- Participante que recibe -->
      <div class="border border-gray-200 rounded-lg p-4">
        <label class="block text-sm font-medium text-green-600 mb-2">
          <svg class="w-4 h-4 inline mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" />
          </svg>
          Participante que RECIBE el cupo
        </label>
        <p-dropdown [options]="participants" [(ngModel)]="toParticipantId" (onChange)="onToParticipantChange()"
          optionLabel="firstName" optionValue="id" [filter]="true" filterBy="firstName,lastName,documentId"
          placeholder="Buscar participante..." styleClass="w-full" [showClear]="true"
          (onFilter)="onSearchParticipants($event)">
          <ng-template let-participant pTemplate="item">
            <div class="flex items-center gap-2">
              <div class="w-8 h-8 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0">
                <span class="text-green-600 text-xs font-medium">
                  {{ participant.firstName?.[0] }}{{ participant.lastName?.[0] }}
                </span>
              </div>
              <div>
                <div class="font-medium">{{ participant.firstName }} {{ participant.lastName }}</div>
                <div class="text-xs text-gray-500">{{ participant.typeDocument }} {{ participant.documentId }}</div>
              </div>
            </div>
          </ng-template>
          <ng-template let-participant pTemplate="selectedItem">
            <div class="flex items-center gap-2" *ngIf="participant">
              <span class="font-medium">{{ participant.firstName }} {{ participant.lastName }}</span>
              <span class="text-xs text-gray-500">({{ participant.documentId }})</span>
            </div>
          </ng-template>
        </p-dropdown>
      </div>
    </div>

    <!-- Motivo -->
    <div class="mt-6">
      <label class="block text-sm font-medium text-gray-700 mb-2">Motivo de la cesión (opcional)</label>
      <textarea [(ngModel)]="reason" rows="3" placeholder="Ingrese el motivo de la cesión de cupo..."
        class="w-full border border-gray-300 rounded-lg p-3 focus:ring-2 focus:ring-purple-500 focus:border-transparent">
      </textarea>
    </div>

    <!-- Advertencia si son el mismo participante -->
    <div *ngIf="fromParticipantId && toParticipantId && fromParticipantId === toParticipantId"
      class="mt-4 p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
      <p class="text-yellow-800 text-sm flex items-center gap-2">
        <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd"
            d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
            clip-rule="evenodd" />
        </svg>
        El participante origen y destino no pueden ser el mismo.
      </p>
    </div>
  </div>

  <!-- STEP 2: Selección de Inscripción -->
  <div *ngIf="step === 2" class="bg-white p-6 rounded-lg shadow-sm">
    <div class="flex items-center mb-6">
      <div class="w-2 h-8 bg-purple-500 rounded mr-3"></div>
      <h3 class="text-lg font-semibold text-gray-800">
        Seleccione la Inscripción {{ enrollmentType === 'corporate' ? 'Empresarial' : 'Individual' }} a Transferir
      </h3>
    </div>

    <!-- Info del participante origen -->
    <div class="mb-6 p-4 bg-gray-50 rounded-lg flex items-center justify-between">
      <p class="text-sm text-gray-600">
        Inscripciones {{ enrollmentType === 'corporate' ? 'empresariales' : 'individuales' }} activas de:
        <span class="font-semibold text-gray-800">{{ getParticipantName(fromParticipantId!) }}</span>
        <span class="text-gray-500 ml-2">({{ getParticipantDocument(fromParticipantId!) }})</span>
      </p>
      <span class="px-2 py-1 text-xs rounded-full font-medium"
        [ngClass]="{'bg-blue-100 text-blue-800': enrollmentType === 'individual', 'bg-purple-100 text-purple-800': enrollmentType === 'corporate'}">
        {{ enrollmentType === 'corporate' ? 'Empresarial' : 'Individual' }}
      </span>
    </div>

    <!-- =========== INSCRIPCIONES INDIVIDUALES =========== -->
    <ng-container *ngIf="enrollmentType === 'individual'">
      <!-- Estado vacío -->
      <div *ngIf="enrollments.length === 0" class="text-center py-12">
        <svg class="w-16 h-16 text-gray-300 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
        <p class="text-gray-500">Este participante no tiene inscripciones individuales activas disponibles para
          transferir.</p>
      </div>

      <!-- Lista de inscripciones individuales -->
      <div *ngIf="enrollments.length > 0" class="space-y-3">
        <div *ngFor="let enrollment of enrollments" class="border-2 rounded-lg p-4 cursor-pointer transition-all"
          [ngClass]="{
            'border-purple-500 bg-purple-50': selectedEnrollmentId === enrollment.id,
            'border-gray-200 hover:border-gray-300': selectedEnrollmentId !== enrollment.id
          }" (click)="selectEnrollment(enrollment.id)">

          <div class="flex items-center justify-between">
            <div class="flex items-center gap-4">
              <input type="radio" [value]="enrollment.id" [checked]="selectedEnrollmentId === enrollment.id"
                class="text-purple-600 focus:ring-purple-500">

              <div>
                <div class="flex items-center gap-2 mb-1">
                  <span class="px-2 py-0.5 bg-blue-100 text-blue-800 text-xs rounded-full font-medium">
                    {{ enrollment.project?.projectId }}
                  </span>
                  <span class="font-medium text-gray-900">{{ enrollment.project?.name }}</span>
                </div>
                <p class="text-sm text-gray-500">{{ enrollment.project?.period }}</p>
              </div>
            </div>

            <div class="text-right">
              <p class="font-semibold text-gray-900">{{ formatCurrency(enrollment.totalAmount) }}</p>
              <p class="text-xs text-gray-500">Inscripción #{{ enrollment.id }}</p>
            </div>
          </div>

          <!-- Detalles adicionales -->
          <div *ngIf="selectedEnrollmentId === enrollment.id" class="mt-4 pt-4 border-t border-purple-200">
            <div class="grid grid-cols-3 gap-4 text-sm">
              <div>
                <span class="text-gray-500">Fecha inscripción:</span>
                <p class="font-medium">{{ enrollment.createdAt | date:'dd/MM/yyyy' }}</p>
              </div>
              <div>
                <span class="text-gray-500">Cuotas:</span>
                <p class="font-medium">{{ enrollment.paymentPlans?.length || 0 }}</p>
              </div>
              <div>
                <span class="text-gray-500">Estado:</span>
                <p class="font-medium text-green-600">Activa</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- =========== INSCRIPCIONES EMPRESARIALES =========== -->
    <ng-container *ngIf="enrollmentType === 'corporate'">
      <!-- Estado vacío -->
      <div *ngIf="corporateEnrollments.length === 0" class="text-center py-12">
        <svg class="w-16 h-16 text-gray-300 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
            d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
        </svg>
        <p class="text-gray-500">Este participante no tiene inscripciones empresariales activas disponibles para
          transferir.</p>
      </div>

      <!-- Lista de inscripciones empresariales -->
      <div *ngIf="corporateEnrollments.length > 0" class="space-y-3">
        <div *ngFor="let corpEnrollment of corporateEnrollments"
          class="border-2 rounded-lg p-4 cursor-pointer transition-all" [ngClass]="{
            'border-purple-500 bg-purple-50': selectedCorporateEnrollment?.id === corpEnrollment.id,
            'border-gray-200 hover:border-gray-300': selectedCorporateEnrollment?.id !== corpEnrollment.id
          }" (click)="selectCorporateEnrollment(corpEnrollment)">

          <div class="flex items-center justify-between">
            <div class="flex items-center gap-4">
              <input type="radio" [value]="corpEnrollment.id"
                [checked]="selectedCorporateEnrollment?.id === corpEnrollment.id"
                class="text-purple-600 focus:ring-purple-500">

              <div>
                <div class="flex items-center gap-2 mb-1">
                  <span class="px-2 py-0.5 bg-purple-100 text-purple-800 text-xs rounded-full font-medium">
                    Empresarial
                  </span>
                  <span class="font-medium text-gray-900">{{ corpEnrollment.project?.name }}</span>
                </div>
                <div class="flex items-center gap-2 text-sm text-gray-500">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                  </svg>
                  <span>{{ corpEnrollment.company?.name }}</span>
                </div>
              </div>
            </div>

            <div class="text-right">
              <p class="text-sm text-gray-500">{{ corpEnrollment.project?.period }}</p>
              <p class="text-xs text-gray-400">ID #{{ corpEnrollment.id }}</p>
            </div>
          </div>

          <!-- Detalles adicionales -->
          <div *ngIf="selectedCorporateEnrollment?.id === corpEnrollment.id"
            class="mt-4 pt-4 border-t border-purple-200">
            <div class="grid grid-cols-3 gap-4 text-sm">
              <div>
                <span class="text-gray-500">Empresa:</span>
                <p class="font-medium">{{ corpEnrollment.company?.name }}</p>
              </div>
              <div>
                <span class="text-gray-500">Cobertura:</span>
                <p class="font-medium">{{ corpEnrollment.defaultCompanyCoveragePercent || 0 }}%</p>
              </div>
              <div>
                <span class="text-gray-500">Estado:</span>
                <p class="font-medium text-green-600">Activa</p>
              </div>
            </div>
            <!-- Advertencia si no se encontró el registro de participante -->
            <div *ngIf="!corpEnrollment.corporateEnrollmentParticipantId"
              class="mt-3 p-2 bg-yellow-50 border border-yellow-200 rounded text-xs text-yellow-700">
              ⚠️ No se encontró el registro de participante asociado. Contacte al administrador.
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <!-- STEP 3: Resumen y Confirmación -->
  <div *ngIf="step === 3" class="bg-white p-6 rounded-lg shadow-sm">
    <div class="flex items-center mb-6">
      <div class="w-2 h-8 bg-purple-500 rounded mr-3"></div>
      <h3 class="text-lg font-semibold text-gray-800">Confirmar Cesión de Cupo</h3>
    </div>

    <!-- Loading de validación -->
    <div *ngIf="validationLoading" class="text-center py-8">
      <div class="animate-spin w-8 h-8 border-4 border-purple-500 border-t-transparent rounded-full mx-auto mb-4"></div>
      <p class="text-gray-500">Validando transferencia...</p>
    </div>

    <!-- Errores de validación -->
    <div *ngIf="!validationLoading && validation && !validation.isValid"
      class="p-4 bg-red-50 border border-red-200 rounded-lg mb-6">
      <h4 class="font-semibold text-red-800 flex items-center gap-2 mb-2">
        <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
            clip-rule="evenodd" />
        </svg>
        La transferencia no es válida
      </h4>
      <ul class="list-disc list-inside text-sm text-red-700 space-y-1">
        <li *ngFor="let error of validation.validationErrors">{{ error }}</li>
      </ul>
    </div>

    <!-- Resumen de la transferencia -->
    <ng-container
      *ngIf="!validationLoading && validation && validation.isValid && validation.transferPreview as preview">
      <div class="space-y-6">

        <!-- Badge tipo de inscripción -->
        <div class="flex justify-center">
          <span class="px-4 py-2 text-sm rounded-full font-medium"
            [ngClass]="{'bg-blue-100 text-blue-800': !preview.isCorporate, 'bg-purple-100 text-purple-800': preview.isCorporate}">
            {{ preview.isCorporate ? 'Cesión Empresarial' : 'Cesión Individual' }}
            <span *ngIf="preview.companyName" class="ml-2">- {{ preview.companyName }}</span>
          </span>
        </div>

        <!-- Visualización de la transferencia -->
        <div class="flex items-center justify-center gap-4 py-6 bg-gray-50 rounded-lg">
          <!-- Origen -->
          <div class="text-center">
            <div class="w-16 h-16 rounded-full bg-red-100 flex items-center justify-center mx-auto mb-2">
              <span class="text-red-600 text-xl font-bold">
                {{ preview.currentParticipantName[0] || '' }}
              </span>
            </div>
            <p class="font-semibold text-gray-800">{{ preview.currentParticipantName }}</p>
            <p class="text-xs text-gray-500">Cede el cupo</p>
          </div>

          <!-- Flecha -->
          <div class="flex items-center">
            <svg class="w-12 h-12 text-purple-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
            </svg>
          </div>

          <!-- Destino -->
          <div class="text-center">
            <div class="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mx-auto mb-2">
              <span class="text-green-600 text-xl font-bold">
                {{ preview.newParticipantName[0] || '' }}
              </span>
            </div>
            <p class="font-semibold text-gray-800">{{ preview.newParticipantName }}</p>
            <p class="text-xs text-gray-500">Recibe el cupo</p>
          </div>
        </div>

        <!-- Detalles de la inscripción -->
        <div class="border border-gray-200 rounded-lg overflow-hidden">
          <div class="bg-gray-50 px-4 py-3 border-b border-gray-200">
            <h4 class="font-semibold text-gray-800">Detalles de la Inscripción</h4>
          </div>
          <div class="p-4">
            <div class="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
              <div>
                <span class="text-gray-500">Proyecto:</span>
                <p class="font-medium text-gray-900">{{ preview.projectName }}</p>
                <p class="text-xs text-gray-500">{{ preview.projectPeriod }}</p>
              </div>
              <div *ngIf="preview.companyName">
                <span class="text-gray-500">Empresa:</span>
                <p class="font-medium text-gray-900">{{ preview.companyName }}</p>
                <p class="text-xs text-gray-500" *ngIf="preview.companyCoveragePercent">Cobertura: {{
                  preview.companyCoveragePercent }}%</p>
              </div>
              <div>
                <span class="text-gray-500">Monto Total:</span>
                <p class="font-medium text-gray-900">{{ formatCurrency(preview.totalAmount || 0) }}</p>
              </div>
              <div>
                <span class="text-gray-500">Monto Pagado:</span>
                <p class="font-medium text-green-600">{{ formatCurrency(preview.paidAmount || 0) }}</p>
              </div>
              <div>
                <span class="text-gray-500">Monto Pendiente:</span>
                <p class="font-medium text-orange-600">{{ formatCurrency(preview.pendingAmount || 0) }}</p>
              </div>
              <div>
                <span class="text-gray-500">Total Cuotas:</span>
                <p class="font-medium text-gray-900">{{ preview.totalInstallments }}</p>
              </div>
              <div>
                <span class="text-gray-500">Cuotas Pagadas:</span>
                <p class="font-medium text-green-600">{{ preview.paidInstallments }}</p>
              </div>
              <div>
                <span class="text-gray-500">Cuotas Pendientes:</span>
                <p class="font-medium text-orange-600">{{ preview.pendingInstallments }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Motivo -->
        <div *ngIf="reason" class="border border-gray-200 rounded-lg p-4">
          <span class="text-sm text-gray-500">Motivo de la cesión:</span>
          <p class="font-medium text-gray-800 mt-1">{{ reason }}</p>
        </div>

        <!-- Advertencia -->
        <div class="p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
          <div class="flex items-start gap-3">
            <svg class="w-5 h-5 text-yellow-600 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd"
                d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                clip-rule="evenodd" />
            </svg>
            <div>
              <h4 class="font-medium text-yellow-800">Esta operación es irreversible</h4>
              <p class="text-sm text-yellow-700 mt-1">
                Una vez confirmada la cesión de cupo, la inscripción será transferida al nuevo participante
                y no podrá deshacerse. Los pagos existentes y pendientes serán asociados al nuevo participante.
              </p>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <!-- Botones de navegación -->
  <div class="flex justify-between items-center bg-white p-4 rounded-lg shadow-sm">
    <button *ngIf="step > 1" (click)="previousStep()"
      class="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition flex items-center gap-2">
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
      </svg>
      Anterior
    </button>
    <div *ngIf="step === 1"></div>

    <button *ngIf="step < 3" (click)="nextStep()"
      class="px-6 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition flex items-center gap-2"
      [disabled]="step === 2 && !hasValidEnrollmentSelection()">
      Siguiente
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
      </svg>
    </button>

    <button *ngIf="step === 3 && validation?.isValid" (click)="submitTransfer()"
      class="px-8 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition flex items-center gap-2">
      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
      </svg>
      Confirmar Cesión
    </button>
  </div>

</div>